module.exports = __webpack_public_path__ + "img/powered-by-swipe-light.74c94f1c.svg";